module.exports = __webpack_public_path__ + "ba12e3272defbe4a5a6ae31744659895.ttf";


//////////////////
// WEBPACK FOOTER
// ../shared/css/rover_icons/fonts/rover-icons.ttf?f8o35m
// module id = 2234
// module chunks = 68